import { useEffect } from 'react'
import { useUserState } from '@/states/user.state'
import initializeGuest from '@/helper/initializeGuest'

export default function useGuestLog() {
  const userState = useUserState.getState()

  useEffect(() => {
    (async function () {
      await initializeGuest()
    })()
  }, [])

  return userState.guestToken
}
